import { emailRegex } from "@/Constants/emailRegex";

export const isValidEmail = (email: string): boolean => {
	return emailRegex.test(email);
};

export const checkValidEmails = (emails: string[]): boolean => {
	return emails.every(isValidEmail);
};
